var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.303,
    height: 51.6,
    viewBox: "0 0 56.303 51.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Shopping_List",
    "data-name": "Shopping List",
    transform: "translate(-386.157 -1682.647)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_51",
    "data-name": "Group 51"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M392.791,1701.959a6.634,6.634,0,1,0,6.634,6.634A6.647,6.647,0,0,0,392.791,1701.959Zm0,10.313a3.678,3.678,0,1,1,3.679-3.679A3.685,3.685,0,0,1,392.791,1712.272Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M392.791,1682.647a6.633,6.633,0,1,0,6.634,6.633A6.646,6.646,0,0,0,392.791,1682.647Zm0,10.313a3.679,3.679,0,1,1,3.679-3.68A3.686,3.686,0,0,1,392.791,1692.96Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M392.791,1720.98a6.633,6.633,0,1,0,6.634,6.634A6.646,6.646,0,0,0,392.791,1720.98Zm0,10.3a3.679,3.679,0,1,1,3.679-3.679A3.685,3.685,0,0,1,392.791,1731.281Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M440.964,1704.287H406.758a1.484,1.484,0,0,0,0,2.967h34.206a1.484,1.484,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M440.964,1709.944H406.758a1.484,1.484,0,0,0,0,2.967h34.206a1.484,1.484,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M440.964,1723.284H406.758a1.483,1.483,0,0,0,0,2.967h34.206a1.483,1.483,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M440.964,1728.953H406.758a1.484,1.484,0,0,0,0,2.967h34.206a1.484,1.484,0,1,0,0-2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M406.771,1688.234h34.206a1.484,1.484,0,0,0,0-2.967H406.758a1.484,1.484,0,0,0,.013,2.967Z",
    fill: "#666"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M440.964,1690.936H406.758a1.483,1.483,0,0,0,0,2.967h34.206a1.483,1.483,0,1,0,0-2.967Z",
    fill: "#666"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCategory);
export default __webpack_public_path__ + "static/media/ic_category.f6d5cc84.svg";
export { ForwardRef as ReactComponent };